import { render, staticRenderFns } from "./external-setting.vue?vue&type=template&id=789cc9c4"
import script from "./external-setting.vue?vue&type=script&lang=js"
export * from "./external-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports